var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":_vm.$options.name,"cancel-title":_vm.$t('form.cancel'),"ok-title":_vm.$t('form.save'),"title":_vm.title,"header-bg-variant":"primary","size":"xl"}},[_vm._v(" : "+_vm._s(_vm.$options.name)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }